import z from 'zod';

export interface ResourceDto {
  title: string;
  findHelpId?: string;
}

export interface ResourceDetailsDto {
  findHelpId?: number;
  title: string;
  providerName: string;
  tags: ResourceTagDto[];
  description: string;
  locations: ResourceLocationDto[];
  websiteUrl: string;
  freeOrReduced: '' | 'free' | 'reduced';
  supportedLanguages: string[];
}

interface Address {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zip?: string;
  description?: string;
  primary?: boolean;
  src?: string;
}
export interface ResourceLocationDto {
  name: string;
  email: string;
  phoneNumber: string;
  hours: {
    day: string;
    open: boolean;
    allDay: boolean;
    startTime: string;
    endTime: string;
  }[];
  timezone: string;
  address: Address;
}

export interface ResourceInteractionDto {
  resource: ResourceDto;
  userNeedId?: number;
  interactionId: number;
}
export interface NeedResourceInteractionDto {
  resource: ResourceDto;
  userNeedId?: number;
  interactionId: number;
}

export interface ResourceTagDto {
  key: string;
  name: string;
  children: ResourceTagDto[];
}

export interface ResourcingRequest {
  title?: string;
  phoneNumber?: string;
  findHelpId?: string;
  userNeedId?: number;
  address?: Address;
}

export const ResourceAddressSchema = z.object({
  line1: z.string().optional(),
  line2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  description: z.string().optional(),
  primary: z.boolean().optional(),
  src: z.string().optional(),
});

export const ResourcingRequestSchema = z.object({
  title: z.string().optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  findHelpId: z.string().optional().nullable(),
  userNeedId: z.number().optional().nullable(),
  address: ResourceAddressSchema.optional().nullable(),
});
export type ResourcingRequestForm = z.infer<typeof ResourcingRequestSchema>;
